import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type MaterialsVolumetricPriceDto = ClientInferResponseBody<
  typeof contract.materials.materialsVolumetricPrices
>;

export const fetchMaterialsVolumetricPrice = async (): Promise<MaterialsVolumetricPriceDto> => {
  const response = await api.materials.materialsVolumetricPrices.query();

  if (response.status === 200) {
    return response.body;
  }

  return [];
};
